import React from "react";

export default function IconHome() {
  return (
    <svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.25 10.0846L3.75 8.55762M3.75 8.55762L9 3.21327L14.25 8.55762M3.75 8.55762V16.1924C3.75 16.6141 4.08579 16.9559 4.5 16.9559H6.75M14.25 8.55762L15.75 10.0846M14.25 8.55762V16.1924C14.25 16.6141 13.9142 16.9559 13.5 16.9559H11.25M6.75 16.9559C7.16421 16.9559 7.5 16.6141 7.5 16.1924V13.1385C7.5 12.7168 7.83579 12.375 8.25 12.375H9.75C10.1642 12.375 10.5 12.7168 10.5 13.1385V16.1924C10.5 16.6141 10.8358 16.9559 11.25 16.9559M6.75 16.9559H11.25"
        stroke="#18181B"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
